/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Switch, FormControlLabel, Typography, Grid, Box } from '@mui/material';
import { TextField } from '@client/new/components/basic';
import { FieldTitle } from './RedStarTitle';
import { LandingMediaDropbox } from './MediaDropBox';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
import {
  emailCaptureSectionSchema,
  EmailCaptureSectionSchema,
} from '@client/pages/CustomProgramPage/OTPLandingPage.schema';

const VStack: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <div className={`flex flex-col gap-2 ${className}`} {...props}>
      {children}
    </div>
  );
};

const InfoText: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Typography variant="body2" color="textSecondary" paragraph>
      {children}
    </Typography>
  );
};

const ImageUpload: React.FC<{
  control: any;
  imageUpload: any;
  name: string;
}> = ({ control, name, imageUpload }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <LandingMediaDropbox
          optional
          upload={imageUpload}
          inputRef={ref}
          label=""
          validationText=""
          value={value}
          onChange={onChange}
          type="image"
          icon={faImage}
          errorMsg={error?.message}
          height="273px"
          width="174px"
        />
      )}
    />
  );
};

export const EmailCaptureForm: React.FC<{
  index: number;
  imageUpload: (file: File) => Promise<string>;
}> = ({ imageUpload, index }) => {
  const { control, register } = useFormContext();
  const r = (s: keyof EmailCaptureSectionSchema) =>
    register(`sections.${index}.${s}`);
  console.log(emailCaptureSectionSchema[0].shape['description']._def);

  return (
    <section>
      <div>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <VStack className="gap-4">
              <InfoText>
                Create a section where user can leave their emails so that you
                can reach out to them with your newsletter and services.
              </InfoText>
              <div>
                <FieldTitle title={'Headline text'} />
                <div className="mb-[5px] max-w-[680px]">
                  <TextField
                    {...r('title')}
                    className="w-full"
                    inputProps={{
                      placeholder: 'Headline text',
                      maxLength: 60,
                    }}
                  />
                </div>
              </div>
              <div>
                <FieldTitle title={'Description'} />
                <div className="mb-[5px] max-w-[680px]">
                  <TextField
                    {...r('description')}
                    className="w-full"
                    multiline
                    rows={5}
                    inputProps={{
                      placeholder: 'Description',
                      maxLength: 240,
                    }}
                  />
                </div>
              </div>{' '}
            </VStack>
          </Grid>

          <Grid item xs={12} md={6}>
            <VStack>
              <Box>
                <Controller
                  name={`sections.${index}.displayAsPopup`}
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <FormControlLabel
                      control={
                        <Switch
                          checked={value}
                          onChange={(e) => onChange(e.target.checked)}
                          color="primary"
                        />
                      }
                      label="Display as Pop-Up"
                    />
                  )}
                />
                <InfoText>
                  Create a pop-up that displays when a visitor opens your
                  website.
                </InfoText>
              </Box>

              <Box>
                <FieldTitle optional title="Image" />
                <Typography variant="body2" color="textSecondary" paragraph>
                  Promotional image that will appear in the pop up. 9:16
                  (Portrait)
                </Typography>

                <ImageUpload
                  imageUpload={imageUpload}
                  control={control}
                  name={`sections.${index}.image`}
                />
              </Box>
            </VStack>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};
